/**
 * url
 */
import qs from 'qs';
import _url from 'url';

const location = window.location;

export default _url;

/**
 * 解析URL的query字符串为对象，默认是当前页面URL
 *
 * @export
 * @param {string} [url=location.href]
 * @returns
 */
export function parseQuery(url = location.href) {
  let urlObj = _url.parse(url);
  let queryObj = qs.parse(urlObj.query);

  // 兼容超级缓存的hashQuery
  if (urlObj.hash) {
    let hashObj = qs.parse(urlObj.hash.substring(1));
    queryObj = {...hashObj, ...queryObj};
  }

  return queryObj;
}



// WEBPACK FOOTER //
// ./src/utils/url.js